import types from '../@types/types';
import '../_shared/vendors/polyfill';
import rMain from './rMain';

new rMain();
